import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface DataPrivacyDialogProps {
  open: boolean;
  onClose: () => void;
}

const DataPrivacyDialog: React.FC<DataPrivacyDialogProps> = ({
  open,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <FormattedMessage
          id="privacy_dialog_title"
          defaultMessage="Data & Privacy"
        />
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="privacy_data_heading"
              defaultMessage="Where is my data stored?"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="privacy_data_body"
              defaultMessage="Your installation data is stored on servers in Switzerland. Only authorized inesco energy personnel can access your data for support purposes."
            />
          </Typography>
        </Box>

        <Divider />

        <Box my={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="privacy_ai_heading"
              defaultMessage="How is AI used?"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="privacy_ai_body"
              defaultMessage="We use an AI service hosted in the European Union to analyze your installation data and provide diagnostic insights. The AI processes technical data such as battery readings and error codes. AI recommendations should always be verified by qualified personnel."
            />
          </Typography>
        </Box>

        <Divider />

        <Box my={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="privacy_browser_heading"
              defaultMessage="What does my browser store?"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="privacy_browser_body"
              defaultMessage="Your browser stores your login session to keep you signed in, and your language and theme preferences. No tracking or advertising cookies are used."
            />
          </Typography>
        </Box>

        <Divider />

        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="privacy_access_heading"
              defaultMessage="Who has access to my data?"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="privacy_access_body"
              defaultMessage="Your data is not shared with third parties. It is used solely to operate the platform and provide you with insights about your installations."
            />
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          <FormattedMessage
            id="privacy_close_button"
            defaultMessage="Close"
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DataPrivacyDialog;
